<template>
    <div id="wrapper">
        <SidebarView :operationImport="true" :operation="true" :operations-visible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />

                <div class="container-fluid">
                    <!-- <div class="card card-shape home-box">
              
            </div> -->
                    <div>
                        <b-card no-body class="card-shape home-box">
                            <b-tabs card>
                                <b-tab title="Fixed Deposit Imports" active>
                                    <FixedDepositImport/>
                                </b-tab>
                                <!-- <b-tab title="Repayment Imports">
                                    <RepaymentImports />
                                </b-tab> -->
                            </b-tabs>
                        </b-card>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import FixedDepositImport from "./FixedDepositImport.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        FixedDepositImport,
        ChatBot,
    },
};
</script>